import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class AprovalProvider {
  
    constructor(public api: Api) { }

    getRequestFamily(params?:any){
        let seq = this.api.get('index.php/myradiant/Aproval/family', params);
        return seq;
    }
    
    getRequestGeneral(params?:any){
        let seq = this.api.get('index.php/myradiant/Aproval/general', params);
        return seq;
    }

    verficationAction(params?:any){
        let seq = this.api.post('index.php/presensi/Permit/verification', params);
        return seq;
    }

    approvalAction(params?:any){
        let seq = this.api.post('index.php/myradiant/Aproval/approve', params);
        return seq;  
    }

    rejectAction(params?:any){
        let seq = this.api.post('index.php/myradiant/Aproval/reject', params);
        return seq;  
    }

    getRequestEditMedical(params?:any){
        params.segment = 'medical';
        let seq = this.api.get('index.php/myradiant/Aproval/itemsEdit', params);
        return seq;
    }
    getRequestEditInsurance(params?:any){
        params.segment = 'insurance';
        let seq = this.api.get('index.php/myradiant/Aproval/itemsEdit', params);
        return seq;
    }
    getRequestEditCeritificate(params?:any){
        params.segment = 'certificate';
        let seq = this.api.get('index.php/myradiant/Aproval/itemsEdit', params);
        return seq;
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/aproval/provider.ts